module.exports = __webpack_public_path__ + "img/htlb.ea888568.png";